<div class="container">
  <div class="maintenance">
    <h1 class="title-h1">{{ 'maintenance_title_label' | translate }}</h1>
    <p>{{ 'maintenance_subTitle_label' | translate }}</p>
  </div>
</div>

